// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvitedModalAccept_dialog__icon__W\\+apl {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  margin-top: 12px;
}
.InvitedModalAccept_dialog__title__typqY {
  font-family: Roboto, serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0;
  color: #272A36;
  margin-bottom: 16px;
  min-width: 300px;
}
.InvitedModalAccept_dialog__notify__ubj7y {
  font-family: Roboto, serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  color: #272A36;
  margin-bottom: 24px;
}
.InvitedModalAccept_dialog__company__7nj4m {
  display: flex;
  align-items: center;
}
.InvitedModalAccept_dialog__companyText__4IyFl {
  font-family: Roboto, serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0;
  text-align: left;
  color: #272A36;
  margin-left: 16px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  max-width: 200px;
}
.InvitedModalAccept_dialog__companyAvatar__eP7cQ {
  flex-grow: 1;
}
.InvitedModalAccept_dialog__action__2og-J {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0 24px 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/InvitedModalAccept/InvitedModalAccept.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;AAFJ;AAGI;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AADN;AAGI;EACE,YAAA;AADN;AAKE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;AAHJ","sourcesContent":[".dialog {\n  &__icon {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 24px;\n    margin-top: 12px;\n  }\n  &__title {\n    font-family: Roboto, serif;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 28px;\n    letter-spacing: 0;\n    color: #272A36;\n    margin-bottom: 16px;\n    min-width: 300px;\n  }\n\n  &__notify {\n    font-family: Roboto, serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0;\n    color: #272A36;\n    margin-bottom: 24px;\n  }\n\n  &__company {\n    display: flex;\n    align-items: center;\n    &Text {\n      font-family: Roboto, serif;\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 19px;\n      letter-spacing: 0;\n      text-align: left;\n      color: #272A36;\n      margin-left: 16px;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      display: -webkit-box;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      word-break: break-all;\n      max-width: 200px;\n    }\n    &Avatar {\n      flex-grow: 1;\n    }\n  }\n\n  &__action {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    padding: 0 24px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog__icon": `InvitedModalAccept_dialog__icon__W+apl`,
	"dialog__title": `InvitedModalAccept_dialog__title__typqY`,
	"dialog__notify": `InvitedModalAccept_dialog__notify__ubj7y`,
	"dialog__company": `InvitedModalAccept_dialog__company__7nj4m`,
	"dialog__companyText": `InvitedModalAccept_dialog__companyText__4IyFl`,
	"dialog__companyAvatar": `InvitedModalAccept_dialog__companyAvatar__eP7cQ`,
	"dialog__action": `InvitedModalAccept_dialog__action__2og-J`
};
export default ___CSS_LOADER_EXPORT___;
